import { computedFrom } from 'aurelia-framework';
import { ValidationRules } from 'aurelia-validation';
import { watch } from 'aurelia-watch-decorator';
import { WidgetController } from 'controls/as-widget-container';
import { RelatedTraveler } from 'model/forms/holiday-trip';
import { WidgetBase } from 'support/base_classes/widget-base';

export class RelatedTravelerWidget extends WidgetBase<RelatedTraveler, WidgetController> {
  bind() {
    this.bindValidation();
  }

  private bindValidation() {
    ValidationRules
      .ensureObject<RelatedTraveler>().required()
      .ensure(model => model.name).displayName(`Traveller #${this.travelerNumber} name`).required().when(model => model.relation != null)
      .ensure(model => model.relation).displayName(`Traveller #${this.travelerNumber} relation`).required().when(model => model.name != null)
      .on(this.model);
  }

  @computedFrom('controller.index')
  get travelerNumber() {
    return this.controller.index + 2;
  }

  @watch((x: RelatedTravelerWidget) => x.travelerNumber)
  private travelerNumberChanged() {
    this.bindValidation();
  }
}
